import React from 'react'
import { motion } from 'framer-motion'
import Button from '@material-ui/core/Button'
import { useNavigate } from 'react-router-dom'

import circles from '../../../assets/images/wage-access/accordion.svg'
import Accordion from '../../../components/accordion/Accordion'
import Footnote from '../../../components/footnote/Footnote'
import Animations from '../../../utils/animations'
import Paths from '../../../utils/paths'
import useStyles from '../PayrollCards.styles'

export default function PayrollCardsAccordion () {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <>
      <div className={classes.accordionContainer}>
        <div className={classes.accordionEmployersContainer}>
          <div className='web-subhead pb-5'>For Employers</div>
          <div className='pb-5 mb-5'>
            <Accordion content={accordion} />
          </div>
        </div>
        <div className={classes.accordionCaptionContainer}>
          <h1 className={classes.accordionTitle}>Why Payroll Cards?</h1>
          <h3>An improved way to pay your team.</h3>
          <Button variant='outlined' className={classes.accordionButton} onClick={() => navigate(Paths.BLOG + '/a-smarter-way-to-get-paid-the-multikrd-payroll-card-is-here')}>
            Learn more about Payroll Cards
          </Button>
        </div>
      </div>
      {/* <Footnote
        notes={['² Source: Bankrate Survey, April 2023', '³ Subject to Terms & Conditions.']}
      /> */}
    </>
  )
}

const accordion = [
  {
    title: 'No More Paper Checks',
    textLine1: 'Save time, reduce processing costs, and eliminate check fraud.'
  },
  {
    disclaimer: '¹ We give you access to your direct deposits from your employer on the day we receive them, which is typically up to 2 days earlier than your scheduled pay date.',
    title: 'Get Paid Up to 2 Days Early¹',
    textLine1: 'Employees may receive their wages early, depending on deposit timing.'
  },
  {
    disclaimer: '² Subject to Terms & Conditions. Central Bank of Kansas City does not administer nor is liable for Pay on-demand /earned wage access or tips access.',
    title: 'Fully Integrated with Earned Wage Access (EWA)²',
    textLine1: 'Give your employees control over when they get paid—before payday, after every shift, or whenever they need it.'
  },
  {
    title: 'Flexible and Secure',
    textLine1: 'Cards can be used in-store, online, or ATMs, and added to Apple Wallet and Google Wallet.'
  },
  {
    title: 'Easy for Everyone',
    textLine1: 'No credit checks. No hidden fees. Just a fast, smart way to get paid.'
  }
]
